/* eslint-disable no-multiple-empty-lines */
/* eslint-disable prefer-destructuring */
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setHelperText,
  ShiftPlanner,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import { ErrorMessages } from "../../../../../Constants";
import {
  dayplusone,
  isIndatetimeBeforeOutdatetime,
  isIntimeBeforeOuttime,
  isIntimeSameBeforeOuttime,
  totalTime,
} from "../../../../../Utils/dates";
import "./index.css";

const styles = (theme) => ({
  root: {
    width: "90%",
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    width: 154,
    height: 20,
    bottom: 3,
    marginBottom: 16,
  },
});

const SHIFTOBJ = {
  shifttimingid: 0,
  shiftbegintime: "10:00",
  shiftendtime: "20:59:00",
  earlycutoff: "00:30",
  endcutoff: "00:30",
  EarlyHrs: 0,
  EarlyMin: 30,
  EndHrs: 0,
  EndMin: 30,
  isdaynight: false,
};

let parentglobaldaynight = false;

class ShiftTimings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftcategoryid: "",
      shiftCount: [{ displayvalue: 1, displayname: "One's" }],
      shifttiming: [
        {
          shiftbegintime: "10:00",
          shiftendtime: "20:59:00",
          earlycutoff: "00:30",
          endcutoff: "00:30",
          EarlyHrs: 0,
          EarlyMin: 30,
          EndHrs: 0,
          EndMin: 30,
          isdaynight: false,
          disable: false,
        },
      ],
      selectedOptions: [],
      earlycutoff: "",
      endcutoff: "",
      shiftbegintime: "",
      shiftendtime: "",
      CommonError: "",
      helperText: "",
      isdaynight: false,
      save: false,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onPrev = this.onPrev.bind(this);
    this.onNextShift = this.onNextShift.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.onFlexibletime = this.onFlexibletime.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("allshiftplanner");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    if (this.props.Language.allshiftplanner) {
      const text = this.props.Language.allshiftplanner.LbShifBeginTimeCount;
      this.props.setHelperText({ helperText: text });
    }

    const { shiftPlannerReducer } = this.props;
    let shifttiming = [];
    let shiftCount;
    const shiftcategoryid = shiftPlannerReducer.shiftcategoryid
      ? shiftPlannerReducer.shiftcategoryid
      : 1;

    if (shiftcategoryid == 1) {
      shiftCount = [{ displayvalue: 1, displayname: " One's" }];
    }

    if (shiftcategoryid == 2) {
      shiftCount = [
        { displayvalue: 1, displayname: " One's" },
        { displayvalue: 2, displayname: " Two's" },
      ];
    }

    if (shiftcategoryid == 3) {
      shiftCount = [
        { displayvalue: 1, displayname: " One's" },
        { displayvalue: 2, displayname: " Two's" },
        { displayvalue: 3, displayname: " Three's" },
      ];
    }

    if (!this.isEmpty(shiftPlannerReducer)) {
      if (
        shiftPlannerReducer.shifttiming.length > 0 &&
        shiftPlannerReducer.shifttiming.length == shiftcategoryid
      ) {
        shifttiming = shiftPlannerReducer.shifttiming;
        shifttiming = shifttiming.map((option, index) => {
          if (index == 0) {
            option.disable = false;
          } else {
            option.disable = true;
          }
          const earlycutoff = option.earlycutoff.split(":");
          option.EarlyHrs = earlycutoff[0];
          option.EarlyMin = earlycutoff[1];
          const endcutoff = option.endcutoff.split(":");
          option.EndHrs = endcutoff[0];
          option.EndMin = endcutoff[1];
          if (index == 0) {
            option.displayname = " One's";
          }
          if (index == 1) {
            option.displayname = " Two's";
          }
          if (index == 2) {
            option.displayname = " Three's";
          }
          return option;
        });
        if (shiftPlannerReducer.shiftid) {
          const shiftWholeData = [...shifttiming];
          shifttiming = shifttiming.map((sft, index) => {
            const val = this.validateShift(shiftWholeData, index);
            return val && val[index];
          });
          // shifttiming = shifttiming.filter((sft) => sft);
          if (shifttiming.some((x) => !x.actualshiftend)) {
            this.props.enqueueSnackbar(
              "Invalid data, please select shift category again",
              { variant: "error" },
            );
            shifttiming = shiftCount.map((item, index) => ({
              ...SHIFTOBJ,
              shiftsequence: item.displayvalue,
              displayname: item.displayname,
              disable: index == 0 ? false : true,
            }));
          }
        }
      } else {
        shifttiming = shiftCount.map((item, index) => ({
          ...SHIFTOBJ,
          shiftsequence: item.displayvalue,
          displayname: item.displayname,
          disable: index == 0 ? false : true,
        }));
      }
      this.setState({ shiftcategoryid, shifttiming }, () =>
        this.UpdateShiftPlannerReducer(),
      );
    }

    this.props.onRef({
      onNext: this.OnNext,
    });
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  handleKeyDown(e) {
    if ([69, 187, 188, 189, 190, 107, 109, 110].includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  onTimeChange(name, option, index, e) {
    if (e != "") {
      const { shifttiming } = this.state;
      if (name == "shiftbegintime") {
        if (e == "00:00") {
          this.props.enqueueSnackbar(ErrorMessages.E1360, { variant: "error" });
          e = "00:01";
        }
        shifttiming[index][name] = e && e.length > 5 ? e : `${e}:00`;
      }

      if (name == "shiftendtime") {
        shifttiming[index][name] = e && e.length > 5 ? e : `${e}:00`;
      }

      switch (name) {
        case "starttimingingHour":
          if (e < 24) {
            console.log("console, ", e);
            shifttiming[index].EarlyHrs = e;
            shifttiming[index].earlycutoff = `${e}:${
              shifttiming[index].EarlyMin == ""
                ? "00"
                : shifttiming[index].EarlyMin
            }:00`;
          }
          break;
        case "starttimingingMin":
          if (e < 60) {
            shifttiming[index].EarlyMin = e;
            shifttiming[index].earlycutoff = `${
              shifttiming[index].EarlyHrs == ""
                ? "00"
                : shifttiming[index].EarlyHrs
            }:${e}:00`;
          }
          break;
        case "cutofftimingingHour":
          if (e < 24) {
            shifttiming[index].EndHrs = e;
            shifttiming[index].endcutoff = `${e}:${
              shifttiming[index].EndMin == "" ? "00" : shifttiming[index].EndMin
            }:00`;
          }
          break;
        case "cutofftimingingMin":
          if (e < 60) {
            shifttiming[index].EndMin = e;
            shifttiming[index].endcutoff = `${
              shifttiming[index].EndHrs == "" ? "00" : shifttiming[index].EndHrs
            }:${e}:00`;
          }
          break;
        default:
          break;
      }
      this.setState({
        shifttiming,
      });
    } else {
      // this.props.enqueueSnackbar("Please enter data", { variant: "error" });
    }
  }

  onPrev(index) {
    let { shifttiming } = this.state;
    shifttiming = shifttiming.map((sft, i) => ({
      ...sft,
      disable: index !== i,
      // shiftbegintime: i > index ? "00:00" : sft.shiftbegintime,
      // shiftendtime: i > index ? "00:00" : sft.shiftendtime,
      // earlycutoff: i > index ? "00:30" : sft.earlycutoff,
      // endcutoff: i > index ? "00:30" : sft.endcutoff,
      // EarlyHrs: i > index ? 0 : sft.EarlyHrs,
      // EarlyMin: i > index ? 30 : sft.EarlyMin,
      // EndHrs: i > index ? 0 : sft.EndHrs,
      // EndMin: i > index ? 30 : sft.EndMin,
      // isdaynight: i > index ? false : sft.isdaynight,
    }));
    this.setState({
      shifttiming,
      save: false,
    });
  }

  validateShift = (shiftArr, index) => {
    const shifttiming = shiftArr;

    // assign isdaynight flag to false first
    shifttiming[index].isdaynight = false;
    shifttiming[index].actualshiftend = "";
    const time1 = moment(shifttiming[index].shiftendtime, ["h:mm A"]).format(
      "HH:mm:ss",
    );
    const time2 = moment(shifttiming[index].endcutoff, ["h:mm A"]).format(
      "HH:mm:ss",
    );

    const durations = [time1, time2];
    const totalDurations = durations
      .slice(1)
      .reduce(
        (prev, cur) => moment.duration(cur).add(prev),
        moment.duration(durations[0]),
      );
    const shiftTimingInput = moment
      .utc(totalDurations.asMilliseconds())
      .format("HH:mm:ss");
    // const number = moment("02:00 PM", ["h:mm A"]).format("HH:mm");

    // is data entered???
    if (
      shifttiming[index].shiftbegintime == "" ||
      shifttiming[index].shiftbegintime == null
    ) {
      this.props.enqueueSnackbar("Please enter shift start time", {
        variant: "error",
      });
      return shifttiming;
    } else if (
      shifttiming[index].shiftendtime == "" ||
      shifttiming[index].shiftendtime == null
    ) {
      this.props.enqueueSnackbar("Please enter shift end time", {
        variant: "error",
      });
      return shifttiming;
    } else if (
      shifttiming[index].shiftbegintime == shifttiming[index].shiftendtime
    ) {
      this.props.enqueueSnackbar("Start time and end time cannot be same", {
        variant: "error",
      });
      return shifttiming;
    } else if (
      shifttiming[index].earlycutoff == "" ||
      shifttiming[index].earlycutoff == null
    ) {
      this.props.enqueueSnackbar("Please enter early leniancy", {
        variant: "error",
      });
      return shifttiming;
    } else if (
      shifttiming[index].endcutoff == "" ||
      shifttiming[index].endcutoff == null
    ) {
      this.props.enqueueSnackbar("Please enter overtime limit", {
        variant: "error",
      });
      return shifttiming;
    } else if (shiftTimingInput == "00:00:00") {
      this.props.enqueueSnackbar(
        " shift end time and overtime limit addition cannot be exact 12",
        { variant: "error" },
      );
      return shifttiming;
    } else if (
      (shifttiming[index].EarlyHrs == "" ||
        shifttiming[index].EarlyHrs == "0" ||
        shifttiming[index].EarlyHrs == "00") &&
      parseInt(shifttiming[index].EarlyMin) < 30
    ) {
      shifttiming[index].EarlyMin = 0;
      shifttiming[index].earlycutoff = "";
      this.props.enqueueSnackbar("Minimum early cut off should be 30 min", {
        variant: "error",
      });
      return shifttiming;
    } else if (
      (shifttiming[index].EndHrs == "" ||
        shifttiming[index].EndHrs == "0" ||
        shifttiming[index].EndHrs == "00") &&
      parseInt(shifttiming[index].EndMin) < 30
    ) {
      shifttiming[index].EndMin = 0;
      shifttiming[index].endcutoff = "";
      this.props.enqueueSnackbar("Minimum end cut off should be 30 min", {
        variant: "error",
      });
      return shifttiming;
    }

    // Lets validate
    // minimum datetime is the "enddatetime" of previous shift. For first, it will be its own shift start time
    const minimumdatetime =
      index === 0
        ? moment(
            `${moment().format("YYYY-MM-DD")} ${
              shifttiming[index].shiftbegintime
            }`,
            "YYYY-MM-DD HH:mm:ss",
          )
            .subtract(shifttiming[index].EarlyHrs, "hours")
            .subtract(shifttiming[index].EarlyMin, "minutes")
            .format("YYYY-MM-DD HH:mm:ss")
        : get(shifttiming, `[${index - 1}].enddatetime`, "");

    // date to be added will be the date of min
    // let date = moment(minimumdatetime).format("YYYY-MM-DD");
    let date =
      index == 0
        ? moment().format("YYYY-MM-DD")
        : moment(
            shifttiming[index - 1].startdatetime,
            "YYYY-MM-DD HH:mm:ss",
          ).format("YYYY-MM-DD");
    const prevshifttimings = shifttiming.slice(0, index);
    const isprevdaynighttrue =
      Array.isArray(prevshifttimings) &&
      prevshifttimings.some((x) => x.isdaynight);
    const shiftbegintimetemp = moment(
      shifttiming[index].shiftbegintime,
      "HH:mm:ss",
    )
      .subtract(shifttiming[index].EarlyHrs, "hours")
      .subtract(shifttiming[index].EarlyMin, "minutes")
      .format("HH:mm:ss");
    if (
      !isIntimeSameBeforeOuttime({
        intime: shiftbegintimetemp,
        outtime: shifttiming[index].shiftbegintime,
      })
    ) {
      this.props.enqueueSnackbar(
        "Minimum end cut off should not go before 12:00 am",
        { variant: "error" },
      );
      return shifttiming;
    }
    if (isprevdaynighttrue && index != 0) {
      date = moment(dayplusone(moment(date, "YYYY-MM-DD"))).format(
        "YYYY-MM-DD",
      );
      parentglobaldaynight = true;
    } else if (
      index > 0 &&
      !isIntimeBeforeOuttime({
        intime: shifttiming[index - 1].actualshiftend,
        outtime: shiftbegintimetemp,
      })
    ) {
      date = moment(dayplusone(moment(date, "YYYY-MM-DD"))).format(
        "YYYY-MM-DD",
      );
      parentglobaldaynight = true;
    }

    // max date will be mindatetime + 24 hrs
    // let maximumdatetime = get(shifttiming, "[0].startdatetime", "") || minimumdatetime;
    let maximumdatetime =
      index == 0 ? minimumdatetime : get(shifttiming, "[0].startdatetime", "");
    maximumdatetime = moment(maximumdatetime)
      .add(24, "hours")
      .format("YYYY-MM-DD HH:mm:ss");

    // set start date and end date
    const startdate = `${date} ${shifttiming[index].shiftbegintime}`;
    const earlydate = moment(startdate, "YYYY-MM-DD HH:mm:ss")
      .subtract(shifttiming[index].EarlyHrs, "hours")
      .subtract(shifttiming[index].EarlyMin, "minutes")
      .format("YYYY-MM-DD HH:mm:ss");

    // check if shift is going in next day
    if (
      (!isprevdaynighttrue || index != 0) &&
      (!isIntimeSameBeforeOuttime({
        intime: moment(shifttiming[index].shiftbegintime, "HH:mm:ss")
          .subtract(shifttiming[index].EarlyHrs, "hours")
          .subtract(shifttiming[index].EarlyMin, "minutes")
          .format("HH:mm:ss"),
        outtime: moment(shifttiming[index].shiftendtime, "HH:mm:ss")
          .add(shifttiming[index].EndHrs, "hours")
          .add(shifttiming[index].EndMin, "minutes")
          .format("HH:mm:ss"),
      }) ||
        !isIntimeSameBeforeOuttime({
          intime: moment(shifttiming[index].shiftbegintime, "HH:mm:ss").format(
            "HH:mm:ss",
          ),
          outtime: moment(shifttiming[index].shiftendtime, "HH:mm:ss").format(
            "HH:mm:ss",
          ),
        }))
    ) {
      const isbegintimegoinginprev = isIntimeSameBeforeOuttime({
        intime: moment(shifttiming[index].shiftbegintime, "HH:mm:ss").format(
          "HH:mm:ss",
        ),
        outtime: moment(shifttiming[index].shiftbegintime, "HH:mm:ss")
          .subtract(shifttiming[index].EarlyHrs, "hours")
          .subtract(shifttiming[index].EarlyMin, "minutes")
          .format("HH:mm:ss"),
      });
      const isendtimegoingnext = isIntimeSameBeforeOuttime({
        intime: moment(shifttiming[index].shiftendtime, "HH:mm:ss")
          .add(shifttiming[index].EndHrs, "hours")
          .add(shifttiming[index].EndMin, "minutes")
          .format("HH:mm:ss"),
        outtime: moment(shifttiming[index].shiftendtime, "HH:mm:ss").format(
          "HH:mm:ss",
        ),
      });

      // date = isendtimegoingnext ? date : moment(dayplusone(moment(date, "YYYY-MM-DD"))).format("YYYY-MM-DD");
      date =
        isbegintimegoinginprev || isendtimegoingnext
          ? date
          : moment(dayplusone(moment(date, "YYYY-MM-DD"))).format("YYYY-MM-DD");
      shifttiming[index].isdaynight = true;
      parentglobaldaynight = true;
    }

    // calculate your enddatetime, date to be appended is already calculated. So, just append it.
    const enddate = `${date} ${shifttiming[index].shiftendtime}`;
    const latedate = moment(enddate, "YYYY-MM-DD HH:mm:ss")
      .add(shifttiming[index].EndHrs, "hours")
      .add(shifttiming[index].EndMin, "minutes")
      .format("YYYY-MM-DD HH:mm:ss");

    console.log("latedate: ", latedate);
    console.log("maximumdatetime: ", maximumdatetime);
    // check two validations
    if (
      !isIndatetimeBeforeOutdatetime({
        indatetime: minimumdatetime,
        outdatetime: earlydate,
      }) &&
      index != 0
    ) {
      this.props.enqueueSnackbar(
        "Shift start time is overlapping with previous shift's end time",
        { variant: "error" },
      );
      return shifttiming;
    } else if (
      !isIndatetimeBeforeOutdatetime({
        indatetime: latedate,
        outdatetime: maximumdatetime,
      })
    ) {
      this.props.enqueueSnackbar(
        "shift timings cannot overlap with each other",
        { variant: "error" },
      );
      return shifttiming;
    }

    // add these keys for next calculation, remember to remove "startdatetime" and "enddatetime", when sending to reducer
    shifttiming[index].startdatetime = earlydate;
    shifttiming[index].enddatetime = latedate;
    shifttiming[index].actualshiftend = moment(latedate).format("HH:mm:ss");
    return shifttiming;
  };

  onNextShift(index) {
    // this.state.ShiftTimings[index];
    const shifttiming = this.validateShift([...this.state.shifttiming], index);
    let flag = shifttiming.slice(0, index + 1);
    flag = flag.findIndex((x) => !x.actualshiftend) == -1; // .some((x) => x.actualshiftend);
    console.log("flag: ", flag);
    if (!flag) {
      return;
    }
    if (shifttiming) {
      if (index == shifttiming.length - 1) {
        shifttiming[index].disable = true;
        this.setState(
          {
            shifttiming,
            save: true,
          },
          () => this.UpdateShiftPlannerReducer(),
        );
      } else {
        shifttiming[index].disable = true;
        if (shifttiming[index + 1]) {
          shifttiming[index + 1].disable = false;
        }
        this.setState(
          {
            shifttiming,
            // save: true,
          },
          () => this.UpdateShiftPlannerReducer(),
        );
      }
    }
  }

  UpdateShiftPlannerReducer() {
    const { shiftPlannerReducer } = this.props;
    const { shifttiming } = this.state;
    shiftPlannerReducer.shifttiming = this.state.shifttiming;
    const index = shifttiming.length - 1;
    const isdaynightflag =
      get(shiftPlannerReducer, "shifttiming", []).findIndex(
        (x) => x.isdaynight,
      ) != -1;
    if (shifttiming[index]) {
      shiftPlannerReducer.isdaynight = isdaynightflag || parentglobaldaynight;
    }
    this.props.ShiftPlanner({ ...shiftPlannerReducer });
  }

  OnNext = () => {
    const { shiftPlannerReducer } = this.props;
    if (shiftPlannerReducer.isflexible) {
      if (shiftPlannerReducer.shifttiming[0].shiftbegintime < "00:30:00") {
        console.log("yyeeee");
        this.props.enqueueSnackbar(
          "Shift start time should be greater than 12.30 AM",
          { variant: "error" },
        );
        return;
      } else {
        this.UpdateShiftPlannerReducer();
        this.props.click();
        return;
      }
    }

    if (this.state.save) {
      this.UpdateShiftPlannerReducer();
      this.setState({
        save: false,
      });
      this.props.click();
    } else {
      this.props.enqueueSnackbar("Please save your shift timings", {
        variant: "error",
      });
      return;
    }
  };

  OnSaveAsDraft() {
    if (this.state.save) {
      this.setState({
        save: false,
      });
      this.UpdateShiftPlannerReducer();
    } else {
      this.props.enqueueSnackbar("Please save your shift timings", {
        variant: "error",
      });
    }
  }

  OnCancel() {
    this.props.Cancel(true);
  }

  onFlexibletime(name, value) {
    console.log("value: ", value);
    const { shifttiming } = this.state;
    shifttiming[0][name] = value;
    let date = new Date();
    date = moment(date).format("YYYY-MM-DD");
    const starttime = `${date} ${value}:00`;
    console.log("starttime: ", starttime);

    shifttiming[0].shiftbegintime = `${value}:00`;
    shifttiming[0].actualshiftend = totalTime({
      timearr: [shifttiming[0].shiftbegintime, "23:29:00"],
    });
    shifttiming[0].shiftendtime = moment(starttime, "YYYY-MM-DD hh:mm:ss")
      .add(22, "hours")
      .add(59, "minutes")
      .format("HH:mm:ss");
    console.log('value == "00.30": ', value == "00:30");
    shifttiming[0].isdaynight = value == "00:30" ? false : true;
    this.setState(
      {
        shifttiming,
      },
      () => this.UpdateShiftPlannerReducer(),
    );
  }

  render() {
    const { classes, shiftPlannerReducer } = this.props;

    return (
      <Grid container>
        <Grid item xs={12} md={12} sm={12}>
          <div
            className="stepper-scroller padding-top-0"
            style={{ width: "100%" }}
          >
            <div className="shift-timing-wrapper margin-top-10">
              <Grid container key="key">
                {!shiftPlannerReducer.isflexible &&
                  this.state.shifttiming.map((option, index) => (
                    <Grid
                      key="key"
                      item
                      xs={12}
                      md={4}
                      sm={12}
                      style={{ padding: 12 }}
                    >
                      <Paper
                        className="no-shadow"
                        style={{
                          background: option.disable ? "white" : "#f7f8f8",
                          padding: 16,
                        }}
                      >
                        <div>
                          <div
                            style={{
                              fontSize: "14",
                              fontWeight: "bold",
                            }}
                          >
                            {this.state.shifttiming.length > 0
                              ? index + 1 == 1
                                ? "First"
                                : index + 1 == 2
                                ? "Second"
                                : "Third"
                              : "Your"}{" "}
                            shift
                          </div>

                          <div className="margin-top-8">
                            <div className="margin-bottom-8">
                              <p className="small-blue">Start time</p>
                            </div>
                            <TextField
                              id="ShifBegin"
                              style={{
                                width: "100%",
                                background: "white",
                                height: 40,
                              }}
                              margin="dense"
                              type="time"
                              dateformat="HH:mm:ss"
                              format="HH:mm:ss"
                              disabled={option.disable}
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              variant="outlined"
                              value={option.shiftbegintime}
                              onChange={(e) =>
                                this.onTimeChange(
                                  "shiftbegintime",
                                  option,
                                  index,
                                  e.target.value,
                                )
                              }
                            />
                          </div>

                          <div className="">
                            <div
                              style={{
                                marginBottom: 8,
                                color: "#057cff",
                              }}
                            >
                              <p className="small-blue">End time</p>
                            </div>
                            <div>
                              <TextField
                                id="ShiftEnd"
                                style={{
                                  width: "100%",
                                  background: "white",
                                  height: 40,
                                }}
                                margin="dense"
                                variant="outlined"
                                type="time"
                                disabled={option.disable}
                                className={classNames(
                                  classes.textField,
                                  classes.dense,
                                )}
                                value={option.shiftendtime}
                                onChange={(e) =>
                                  this.onTimeChange(
                                    "shiftendtime",
                                    option,
                                    index,
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>

                          <div className="" style={{ marginBottom: 20 }}>
                            <div
                              style={{
                                marginBottom: 8,
                                display: "flex",
                              }}
                            >
                              <p className="small-blue margin-right-8">
                                Start-off
                              </p>
                              <Tooltip
                                title="Time (hours) before the actual shift start-time when employees will be allowed to clock-in (begin attendance)"
                                placement="right-end"
                              >
                                <p className="margin-top-0 margin-bottom-0">
                                  ℹ️
                                </p>
                              </Tooltip>
                            </div>
                            <div className="">
                              <span
                                className=""
                                style={{ marginRight: 5, textAlign: "left" }}
                              >
                                <input
                                  className="shiftTimingInput"
                                  type="number"
                                  min="00"
                                  max="23"
                                  disabled={option.disable}
                                  placeholder="Hrs"
                                  onChange={(e) =>
                                    this.onTimeChange(
                                      "starttimingingHour",
                                      option,
                                      index,
                                      e.target.value,
                                    )
                                  }
                                  value={option.EarlyHrs}
                                  onKeyDown={(e) => this.handleKeyDown(e)}
                                />
                                <span> hrs</span>
                              </span>
                              <span className="" style={{ textAlign: "right" }}>
                                <input
                                  className="shiftTimingInput"
                                  type="number"
                                  min={
                                    !option.EarlyHrs || option.EarlyHrs == 0
                                      ? // || option.EarlyHrs == "00"
                                        "30"
                                      : "00"
                                  }
                                  max="59"
                                  disabled={option.disable}
                                  placeholder="30"
                                  onChange={(e) =>
                                    this.onTimeChange(
                                      "starttimingingMin",
                                      option,
                                      index,
                                      e.target.value,
                                    )
                                  }
                                  value={option.EarlyMin}
                                  onKeyDown={(e) => this.handleKeyDown(e)}
                                />
                                <span> mins</span>
                              </span>
                            </div>
                          </div>

                          <div>
                            <div
                              style={{
                                marginBottom: 8,
                                display: "flex",
                              }}
                            >
                              <p className="small-blue margin-right-8">
                                Cut-off
                              </p>
                              <Tooltip
                                placement="right-end"
                                title="Employees will be allowed to clock-out until cut-off time after the actual shift end time"
                              >
                                <p className="margin-top-0 margin-bottom-0">
                                  ℹ️
                                </p>
                              </Tooltip>
                            </div>
                            <div className="">
                              <span
                                className=""
                                style={{ marginRight: 5, textAlign: "left" }}
                              >
                                <input
                                  className="shiftTimingInput"
                                  type="number"
                                  min="00"
                                  disabled={option.disable}
                                  max="23"
                                  placeholder="Hrs"
                                  onChange={(e) =>
                                    this.onTimeChange(
                                      "cutofftimingingHour",
                                      option,
                                      index,
                                      e.target.value,
                                    )
                                  }
                                  value={option.EndHrs}
                                  onKeyDown={(e) => this.handleKeyDown(e)}
                                />
                                <span> hrs</span>
                              </span>
                              <span className="" style={{ textAlign: "right" }}>
                                <input
                                  className="shiftTimingInput"
                                  type="number"
                                  disabled={option.disable}
                                  min={
                                    !option.EndHrs || option.EndHrs == 0
                                      ? // || option.EndHrs == "00"
                                        "30"
                                      : "00"
                                  }
                                  max="59"
                                  placeholder="30"
                                  onChange={(e) =>
                                    this.onTimeChange(
                                      "cutofftimingingMin",
                                      option,
                                      index,
                                      e.target.value,
                                    )
                                  }
                                  value={option.EndMin}
                                  onKeyDown={(e) => this.handleKeyDown(e)}
                                />
                                <span> mins</span>
                              </span>
                            </div>
                          </div>

                          <div
                            style={{
                              marginTop: 16,
                              marginBottom: index == 0 && 10,
                            }}
                          >
                            <Button
                              className="prevshift"
                              variant="text"
                              color="primary"
                              disabled={!option.disable}
                              onClick={() => this.onPrev(index, index != 0)}
                            >
                              Edit
                              {/* {index != 0 ? "Previous" : "Edit"} */}
                            </Button>
                            <Button
                              className="nextshift"
                              variant="text"
                              color="primary"
                              disabled={option.disable}
                              onClick={() => this.onNextShift(index)}
                            >
                              {index != this.state.shifttiming.length - 1
                                ? "Next"
                                : "Save"}
                            </Button>
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ))}
                {shiftPlannerReducer.isflexible && (
                  <div>
                    <div
                      className=""
                      style={{
                        marginBottom: 8,
                        color: "#057cff",
                      }}
                    >
                      <p className="small-blue"> Start time</p>
                    </div>
                    <TextField
                      id="ShifBegin"
                      style={{
                        width: "200px",
                        background: "white",
                        height: 40,
                      }}
                      margin="dense"
                      type="time"
                      className={classNames(classes.textField, classes.dense)}
                      variant="outlined"
                      value={this.state.shifttiming[0].shiftbegintime}
                      onChange={(e) =>
                        this.onFlexibletime("shiftbegintime", e.target.value)
                      }
                    />
                  </div>
                )}
              </Grid>
              {/* <div className="padding-top-20 padding-bottom-10">
                <Button variant="contained" color="primary" size="large" onClick={this.OnNext.bind(this)}>
                  <FormattedMessage id="BtNext" defaultMessage="next" />
                </Button>
              </div> */}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  shiftPlannerReducer: state.shiftPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      ShiftPlanner: (data) => ShiftPlanner(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ShiftTimings)));
